module.exports = __webpack_public_path__ + "img/sidebar-battery-10.6e340ed7.svg";